class BaseElement extends HTMLElement
{
  constructor () {
    super();

    this.safeEventListeners = [];
    this.safeWindowEventListeners = [];
    this.safeDocumentEventListeners = [];

    if (/complete|interactive|loaded/.test(document.readyState)) {
      setTimeout(this.init.bind(this), 1);
    } else {
      this.onDocumentLoaded(() => this.init());
    }
  }

  // called on document loaded
  init () {}

  connectedCallback () {
    // Add event listeners again after DOM is moved
    this.safeEventListeners.forEach(event => {
      this.addEventListener(event.type, event.listener, event.options);
    });

    this.safeDocumentEventListeners.forEach(event => {
      document.addEventListener(event.type, event.listener, event.options);
    });

    this.safeWindowEventListeners.forEach(event => {
      window.addEventListener(event.type, event.listener, event.options);
    });
  }

  disconnectedCallback () {
    this.safeEventListeners.forEach(event => {
      this.removeEventListener(event.type, event.listener);
    });

    this.safeDocumentEventListeners.forEach(event => {
      document.removeEventListener(event.type, event.listener);
    });

    this.safeWindowEventListeners.forEach(event => {
      window.removeEventListener(event.type, event.listener);
    });
  }

  // Add event listener which will be removed after DOM is removed
  addSafeEventListener(type, listener, options) {
    this.safeEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    this.addEventListener(type, listener, options);
  }

  // Add document event listener which will be removed after DOM is removed
  addSafeDocumentEventListener(type, listener, options) {
    this.safeDocumentEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    document.addEventListener(type, listener, options);
  }

  // Add window event listener which will be removed after DOM is removed
  addSafeWindowEventListener(type, listener, options) {
    this.safeWindowEventListeners.push({
      type: type,
      listener: listener,
      options: options
    });

    window.addEventListener(type, listener, options);
  }

  onBroadcast (eventName, listener) {
    const wrapper = e => {
      listener.apply(null, [e.detail]);
    };

    this.addSafeDocumentEventListener(eventName, wrapper);
  }

  onDocumentLoaded (listener) {
    this.addSafeWindowEventListener('DOMContentLoaded', listener);
  }
}

function objectDeepMerge (target, source) {
  if (!target) return source;
  if (!source) return target;

  if (typeof target !== 'object' || typeof source !== 'object') {
    return source;
  }

  if (Array.isArray(target) && Array.isArray(source)) {
    return [...target, ...source];
  }

  const result = { ...target };

  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      const sourceValue = source[key];
      const targetValue = target[key];

      if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
        // Recurse for nested objects
        result[key] = objectDeepMerge(targetValue, sourceValue);
      } else {
        result[key] = sourceValue;
      }
    }
  }

  return result;
}

function broadcast (eventName, data) {
  document.dispatchEvent(new CustomEvent(eventName, {
    detail: data
  }));
}

function onBroadcast (eventName, listener) {
  document.addEventListener(eventName, e => {
    listener.apply(null, [e.detail]);
  });
}